import { render, staticRenderFns } from "./EditorControls.vue?vue&type=template&id=b37ff77e&scoped=true&"
import script from "./EditorControls.vue?vue&type=script&lang=js&"
export * from "./EditorControls.vue?vue&type=script&lang=js&"
import style0 from "./EditorControls.vue?vue&type=style&index=0&id=b37ff77e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37ff77e",
  null
  
)

export default component.exports